module.exports = __webpack_public_path__ + "static/img/25.f1cedff8.jpg";